// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"FilterCheckBox_root__7B8TP","checkBox":"FilterCheckBox_checkBox__UXrB9","checked":"FilterCheckBox_checked__zc2BA"};